<div nz-flex [nzVertical]="true" class="bgColor p-10">
  <nz-row nzGutter="24" class="rows displayFlex">
    <nz-col nzSpan="22">
      <div nz-row class="mt-2 mb-2">
        <div nz-col nzSpan="3" class="title">{{ application.menu }}</div>
        <div nz-col nzSpan="21" class="title">{{ application.reports }}</div>
      </div>

      <nz-tabs [nzTabPosition]="'left'" id="reportTabs">
        <nz-tab nzTitle="TimeSheet">
          <app-timesheet-reports> </app-timesheet-reports>
        </nz-tab>
      </nz-tabs>
    </nz-col>
  </nz-row>
</div>
